import { createContext } from 'react';

export const EthersContext = createContext("");